import { render, staticRenderFns } from "./diyToolTip.vue?vue&type=template&id=2d22ce95&scoped=true"
import script from "./diyToolTip.vue?vue&type=script&lang=js"
export * from "./diyToolTip.vue?vue&type=script&lang=js"
import style0 from "./diyToolTip.vue?vue&type=style&index=0&id=2d22ce95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22ce95",
  null
  
)

export default component.exports